import type { I18nLocale } from "@/modules/i18n/types"

import { RESULTS_SORT_OPTIONS_MAPPING } from "@/modules/jobAds/client/constants"
import { COMPANY_ADMIN_ROLES, RECRUITER_ADMIN_ROLES } from "@/modules/user/api/types"

export const TALENT_CONNECT_NAME = "TalentConnect"

export const QUERY_CACHE_TIME = 30 * 60 * 1000 // 30 min
export const QUERY_STALE_TIME = 15 * 60 * 1000 // 15 min
export const LIVE_QUERY_STALE_TIME = 3 * 1000 // 3 sec

export const TALENT_CONNECT_SESSION_COOKIE_NAME = "talent_connect_session"

const FEATURE_BASE_PATH = "talent-connect"
const BO_FEATURE_BASE_PATH = "backend/talent-connect"

export const LANDING_PAGE_PATH = `${FEATURE_BASE_PATH}/events/{eventSlug}`
export const LOGIN_PAGE_PATH = `${FEATURE_BASE_PATH}/events/{eventSlug}/login`
export const ACCESS_DENIED_PAGE_PATH = `${FEATURE_BASE_PATH}/events/{eventSlug}/access-denied`
export const NOT_AUTHORIZED_PAGE_PATH = `${FEATURE_BASE_PATH}/events/{eventSlug}/not-authorized`
export const FUTURE_EVENT_PAGE_PATH = `${FEATURE_BASE_PATH}/events/{eventSlug}/event-not-started`
export const PAST_EVENT_PAGE_PATH = `${FEATURE_BASE_PATH}/events/{eventSlug}/event-finished`
export const RATE_LIMIT_PAGE_PATH = `${FEATURE_BASE_PATH}/events/{eventSlug}/rate-limit`
export const EMAIL_NOT_CONFIRM_PAGE_PATH = `${FEATURE_BASE_PATH}/events/{eventSlug}/email-not-confirmed`
export const SEARCH_PAGE_PATH = `${FEATURE_BASE_PATH}/events/{eventSlug}/search`
export const TALENTS_PAGE_PATH = `${FEATURE_BASE_PATH}/events/{eventSlug}/talents`
export const TALENT_DETAILS_PAGE_PATH = `${FEATURE_BASE_PATH}/events/{eventSlug}/talents/{talentId}`
export const COMPANY_JOB_OFFERS_PAGE_PATH = `${FEATURE_BASE_PATH}/events/{eventSlug}/companies/{companySlug}/job-offers`
export const BO_TALENT_CONNECT_HOMEPAGE_PATH = `${BO_FEATURE_BASE_PATH}/events`

export const IS_FROM_SLIDE_PANEL_PARAM = "from_slide_panel"

export const INPUT_DEBOUNCE_DELAY_IN_MS = 300
export const MIN_QUERY_LENGTH = 2
export const NB_DEFAULT_SEARCH_PAGE_SIZE = 50

export const ALGOLIA_TALENT_INDEX_NAME = RESULTS_SORT_OPTIONS_MAPPING.RELEVANCE // TODO use another var env for the feature

export const OFFER_DETAIL_PANEL_CONTAINER_ID = "offer-detail-panel-container"
export const TALENTS_PANEL_CONTAINER_ID = "talents-panel-container"

// Authorized roles to access the Talent Connect feature are company admins + (private) company school admins from CC
const AUTHORIZED_ROLES = [...COMPANY_ADMIN_ROLES, RECRUITER_ADMIN_ROLES[1]]

export const COMPANY_EVENT_MANAGEMENT_ROLES = AUTHORIZED_ROLES.filter(role =>
  ["company_super_admin", "company_admin", "company_school_admin", "company_campus_manager"].includes(role)
)

export const TALENT_CONNECT_ENDPOINT_BASE_URL = "/v1/company-talents"

export const GET_TALENT_CONNECT_EVENT_ERRORS = {
  NOT_AUTHORIZED: "Talent Connect Event: User not authorized.",
  NOT_FOUND: "Talent Connect Event: Event not found.",
}

export const GET_COMPANY_TALENT_ERRORS = {
  NOT_FOUND: "Company Talent: Talent not found.",
  RATE_LIMIT: "Company Talent: Rate limit exceeded.",
}

export const DOMAIN_NAME_NOT_MATCHING_ERROR_MESSAGE = "Domain name not matching"

export const FILTER_KEYS = ["q", "rating", "user_course_ids"]

export const TALENT_CONNECT_ALLOWED_LOCALES: I18nLocale[] = ["en", "fr"]

export const SKELETON_MAIN_THEME = {
  baseColor: "var(--sk-color-grey-100)",
  highlightColor: "var(--sk-color-grey-025)",
}
export const TALENT_CONNECT_MAX_FILE_SIZE_IN_MB = 8
export const TALENT_CONNECT_MAX_FILE_SIZE_IN_BYTES = TALENT_CONNECT_MAX_FILE_SIZE_IN_MB * 1024 * 1024 // 8 MB

export const TALENT_CONNECT_ACCEPTED_TYPES = ["application/pdf", "image/png", "image/jpeg"]
export const TALENT_CONNECT_ACCEPTED_EXTENSIONS = [".pdf", ".png", ".jpg", ".jpeg"]
